// extracted by mini-css-extract-plugin
module.exports = {"entry":"Info_entry-1omk0","label":"Info_label-28zE0"};